import { WeatherCondition } from "interfaces/Weather";

export const getWeatherIconPath = (weather: WeatherCondition): string => {
  try {
    return require(`assets/images/weather/${weather.icon}.svg`);
  } catch (error) {
    return `//openweathermap.org/img/wn/${weather.icon}.png`;
  }
};
